export default function TrainingFormats() {
  const formats = [
    { icon: 'ri-building-2-line', title: 'Корпоративный тренинг', desc: 'Обучение команды в формате интенсивного тренинга: 1–2 полных дня практики, кейсов и отработки навыков. Максимальная концентрация и погружение.' },
    { icon: 'ri-computer-line', title: 'Онлайн-формат', desc: 'Живые сессии через видеосвязь с отработкой диалогов, разбором кейсов и ролевыми упражнениями. Полноценный тренинг без потери эффективности.' },
    { icon: 'ri-group-line', title: 'Оффлайн-формат', desc: 'Тренинг в вашем офисе или на внешней площадке. Живое общение, работа в группах, энергия зала — для максимального вовлечения команды.' },
    { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Серия занятий на 2–3 месяца с домашними заданиями и разбором результатов между модулями. Глубокое погружение и устойчивые изменения.' },
    { icon: 'ri-repeat-line', title: 'Серия тренингов', desc: 'Несколько тренингов с разными фокусами: базовая коммуникация → работа с возражениями → удержание клиентов. Системное развитие команды.' },
    { icon: 'ri-user-voice-line', title: 'С сопровождением', desc: 'Тренинг + посттренинговое сопровождение: разбор реальных коммуникаций, поддержка в чате, аудит, корректировка. Для устойчивого результата.' },
    { icon: 'ri-settings-line', title: 'Индивидуальная программа', desc: 'Полная адаптация под бизнес: продукт, рынок, категории клиентов, уровень подготовки команды. Ни одной шаблонной темы.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-layout-line"></i>
            Выберите формат
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Форматы обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            От интенсивного однодневного тренинга до комплексной программы с сопровождением — формат подбирается под задачи, бюджет и масштаб компании.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {formats.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}